// Wizard App
import * as Vue from 'vue';
import Wizard from './containers/wizard.vue';

const app = Vue.createApp(Wizard);
app.mount('#wizard-app');